import { AlertCircle } from "lucide-react";
import React from "react";

import { cn } from "@/lib/utils";

export const InlineError: React.FC<{
  message: string;
  className?: string;
}> = ({ message, className }) => (
  <p
    role="alert"
    className={cn(
      "fade-in flex max-w-sm items-start gap-1.5 text-xs leading-5 text-rose-600 dark:text-rose-400",
      className,
    )}
  >
    <AlertCircle className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden />
    {message}
  </p>
);
